// Oct 27, 2026: Anodyne "Inserts" chooser (snippets/hm-anodyne-inserts.liquid). Finds the chooser for a form,
// blocks add to cart until a choice is made, and works out the size-matched insert variant from the shoe SKU.
window.HMInserts = window.HMInserts || (function () {
  function forForm(formId) {
    return formId ? document.querySelector('[data-hm-inserts][data-form-id="' + formId + '"]') : null;
  }
  function data(root) {
    if (!root._hmData) {
      try { root._hmData = JSON.parse(root.querySelector('[data-hm-inserts-data]').textContent); } catch (e) { root._hmData = { variants: {}, gel: {}, md: {} }; }
    }
    return root._hmData;
  }
  function insertSku(shoeSku, kind) {
    const m = String(shoeSku || '').trim().match(/^([MW]).*?(\d{3})$/i);
    if (!m) return null;
    const g = m[1].toUpperCase();
    return kind === 'gel' ? g + 'GL-' + m[2] : g + 'MD-S-' + m[2];
  }
  function resolve(root, variantId, kind) {
    const d = data(root);
    const sku = insertSku(d.variants[String(variantId)], kind);
    const v = sku ? d[kind][sku] : null;
    return v && v.available ? { id: v.id, sku: sku, shoeSku: d.variants[String(variantId)] } : null;
  }
  function choice(root) {
    const c = root.querySelector('input[type=radio]:checked');
    return c ? c.value : null;
  }
  function setError(root, on) {
    root.classList.toggle('hm-inserts--invalid', on);
    root.querySelector('[data-hm-inserts-error]').hidden = !on;
    root.querySelectorAll('input[type=radio]').forEach((i) => i.setAttribute('aria-invalid', on ? 'true' : 'false'));
  }
  function refresh(root, variantId) {
    const gap = root.querySelector('[data-hm-inserts-gap]');
    const missing = [];
    ['gel', 'md'].forEach((kind) => {
      const input = root.querySelector('input[value="' + kind + '"]');
      const ok = !!resolve(root, variantId, kind);
      input.disabled = !ok;
      if (!ok) { missing.push(input.dataset.label); if (input.checked) { input.checked = false; update(root); } }
    });
    gap.hidden = missing.length === 0;
    gap.textContent = missing.length ? missing.join(' and ') + (missing.length > 1 ? ' are' : ' is') + ' not available in this size. Choose another option or call us for help.' : '';
  }
  function update(root) {
    const c = root.querySelector('input[type=radio]:checked');
    root.querySelector('[data-hm-inserts-selected]').textContent = c ? c.dataset.label : 'Choose one';
    if (c) setError(root, false);
  }
  function init(root) {
    if (root._hmInit) return; root._hmInit = true;
    root.addEventListener('change', () => update(root));
    const form = document.getElementById(root.dataset.formId);
    const idInput = form && form.querySelector('[name=id]');
    if (idInput) refresh(root, idInput.value);
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        const v = e && e.data && e.data.variant;
        if (v && document.body.contains(root)) refresh(root, v.id);
      });
    }
  }
  function initAll() { document.querySelectorAll('[data-hm-inserts]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  return { forForm, resolve, choice, setError, refresh, initAll };
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Anodyne inserts: a choice is required, and the matching insert is added after the shoe.
        const hmRoot = window.HMInserts.forForm(this.form.getAttribute('id'));
        let hmInsert = null;
        if (hmRoot) {
          const hmChoice = window.HMInserts.choice(hmRoot);
          if (!hmChoice) {
            window.HMInserts.setError(hmRoot, true);
            const first = hmRoot.querySelector('input[type=radio]:not(:disabled)');
            hmRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (first) first.focus({ preventScroll: true });
            return;
          }
          if (hmChoice !== 'none') {
            hmInsert = window.HMInserts.resolve(hmRoot, this.variantIdInput.value, hmChoice);
            if (!hmInsert) {
              window.HMInserts.refresh(hmRoot, this.variantIdInput.value);
              return;
            }
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const hmShoeData = hmInsert ? new FormData(this.form) : null;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        let hmRequest;
        if (hmInsert) {
          // 1) add the shoe on its own, 2) add the insert with the same quantity and ask for the cart sections to render.
          const insertData = new FormData();
          insertData.append('id', hmInsert.id);
          insertData.append('quantity', formData.get('quantity') || '1');
          insertData.append('properties[_For shoe]', hmInsert.shoeSku || '');
          if (this.cart) {
            insertData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            insertData.append('sections_url', window.location.pathname);
          }
          const shoeConfig = Object.assign({}, config, { body: hmShoeData });
          hmRequest = fetch(`${routes.cart_add_url}`, shoeConfig)
            .then((r) => r.json())
            .then((shoe) => {
              if (shoe.status) return shoe;
              return fetch(`${routes.cart_add_url}`, Object.assign({}, config, { body: insertData }))
                .then((r) => r.json())
                .then((ins) => {
                  if (!ins.status) return ins;
                  // Shoe is in the cart but the insert failed: show why without marking the shoe sold out.
                  this.handleErrorMessage('Your shoes were added, but the insert could not be: ' + (ins.description || ins.message));
                  if (this.cart) {
                    return fetch(`${routes.cart_url}?sections=${this.cart.getSectionsToRender().map((s) => s.id).join(',')}`)
                      .then((r) => r.json())
                      .then((sections) => Object.assign({}, shoe, { sections }));
                  }
                  return shoe;
                });
            });
        } else {
          hmRequest = fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
        }

        hmRequest
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}





